// LoadingContext.js
import { createContext, Dispatch, FC, ReactNode, useState } from "react";

interface ILoadingContext {
  loading: boolean;
  setLoading: Dispatch<React.SetStateAction<boolean>>;
}

export const LoadingContext = createContext<ILoadingContext | undefined>(
  undefined
);

export const LoadingProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const value = { loading, setLoading };
  return (
    <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
  );
};